import React from "react"

import AdminFeatures from "../components/homeAdminFeatures"
import Fold from "../components/fold"
import HomeService from "../components/homeService"
import MoreFeatures from "../components/homeMoreFeatures"
import HomeSupport from "../components/homeSupport"
import HomeTemplates from "../components/homeTemplates"
// import HomeTestimonial from "../components/homeTestimonial"
import Layout from "../components/layout"
import SEO from "../components/seo"
import LastCall from "../components/homeLastCall"

const IndexPage = ({ location }) => (
  <Layout path={location.pathname}>
    <SEO slug="/index" />
    <Fold />
    <HomeService />
    <AdminFeatures />
    <MoreFeatures />
    <HomeTemplates />
    <HomeSupport />
    {/* <HomeTestimonial /> */}
    <LastCall />
  </Layout>
)

export default IndexPage
